import { useMutation, useQuery } from 'react-query'

import { QueryKey } from '../../../common/api'
import { queryClient } from '../../../common/providers/query'
import { duLabelApi } from '../api/du-labels.api'
import { DuLabel } from '../types/du-label.types'

export const useGetDuLabels = () => {
  return useQuery([QueryKey.DuLabels], async () => {
    const result = await duLabelApi.getLabels()

    return result.data
  })
}

export const useCreateDuLabel = () => {
  return useMutation(
    async (label: Omit<DuLabel, 'id'>) => {
      const result = await duLabelApi.createLabel(label)

      return result.data
    },
    {
      onSuccess: () => {
        return queryClient.invalidateQueries(QueryKey.DuLabels)
      },
    },
  )
}

export const useUpdateDuLabel = () => {
  return useMutation(
    async (label: DuLabel) => {
      const { id, ...data } = label
      const result = await duLabelApi.updateLabel(id, data)

      return result.data
    },
    {
      onSuccess: () => {
        return Promise.all([queryClient.invalidateQueries(QueryKey.DuLabels), queryClient.invalidateQueries(QueryKey.Objects)])
      },
    },
  )
}

export const useDeleteLabel = () => {
  return useMutation(
    async (id: number) => {
      await duLabelApi.deleteLabel(id)
    },
    {
      onSuccess: async () => {
        return Promise.all([queryClient.invalidateQueries(QueryKey.DuLabels), queryClient.invalidateQueries(QueryKey.Objects)])
      },
    },
  )
}
